/** Read-aloud for kids who can't read yet. Silently does nothing where the device has no speech. */

const MUTE_KEY = "mr.readAloudMuted";

export function isSpeechMuted(): boolean {
  try {
    return localStorage.getItem(MUTE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSpeechMuted(muted: boolean) {
  try {
    if (muted) localStorage.setItem(MUTE_KEY, "1");
    else localStorage.removeItem(MUTE_KEY);
  } catch {
    // Private mode: the choice just won't stick.
  }
  if (muted && "speechSynthesis" in window) window.speechSynthesis.cancel();
}

export function speak(text: string) {
  if (!("speechSynthesis" in window) || isSpeechMuted()) return;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(new SpeechSynthesisUtterance(text));
}
